import { OnboardingTarget, onboardingTarget } from "../onboarding/onboardingTargets";
import classNames from "classnames";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { SelectedTab, selectSelectedTab } from "../../app/slices/GlobalSlice";
import {
  selectSelectedElementType,
  selectTrainingType,
  TrainingType,
} from "../../app/slices/TrainingSlice";
import {
  ActorPresetPropertiesColumnContent,
  ActorStatePropertiesColumnContent,
  InteractionPropertiesColumnContent,
  PropPresetPropertiesColumnContent,
  Take360PropertiesColumnContent,
  Take3DCameraPropertiesColumnContent,
  Take3DPropertiesColumnContent,
} from "./PropertiesColumnContent";

export default function PropertiesColumn() {
  const selectedTab = useSelector(selectSelectedTab);
  const selectedElementType = useSelector(selectSelectedElementType);
  const trainingType = useSelector(selectTrainingType);
  const is3DNonTimelineTab =
    trainingType === TrainingType.Training3D &&
    selectedTab !== SelectedTab.Timeline;

  const { strategy, isNewStyle } = useMemo(() => {
    if (is3DNonTimelineTab) return { strategy: undefined, isNewStyle: false };

    if (
      trainingType !== TrainingType.Training3D &&
      selectedTab === SelectedTab.ActorPresets
    )
      return { strategy: ActorPresetPropertiesColumnContent, isNewStyle: false };
    else if (
      trainingType !== TrainingType.Training3D &&
      selectedTab === SelectedTab.PropPresets
    )
      return { strategy: PropPresetPropertiesColumnContent, isNewStyle: false };
    else {
      if (
        trainingType === TrainingType.Training360 &&
        selectedElementType === "take"
      ) {
        return { strategy: Take360PropertiesColumnContent, isNewStyle: true };
      } else if (selectedElementType === "camera") {
        return {
          strategy: Take3DCameraPropertiesColumnContent,
          isNewStyle: true,
        };
      } else if (
        selectedElementType === "take" ||
        selectedElementType === "transition"
      ) {
        return { strategy: Take3DPropertiesColumnContent, isNewStyle: true };
      } else if (
        selectedElementType === "interaction" ||
        selectedElementType === "takeSequence"
      ) {
        return { strategy: InteractionPropertiesColumnContent, isNewStyle: true };
      } else if (selectedElementType === "actor") {
        return selectedTab === SelectedTab.Timeline
          ? { strategy: Take3DPropertiesColumnContent, isNewStyle: true }
          : { strategy: ActorStatePropertiesColumnContent, isNewStyle: true };
      }
    }

    return { strategy: undefined, isNewStyle: false };
  }, [is3DNonTimelineTab, selectedTab, selectedElementType, trainingType]);

  if (is3DNonTimelineTab) return null;

  const columnWidth =
    selectedTab !== SelectedTab.Timeline
      ? "w-full"
      : "w-[250px] min-w-[250px]";

  return (
    <div
      aria-label="property-column"
      {...onboardingTarget(OnboardingTarget.EditorPropertiesColumn)}
      className={classNames(
        "relative h-full",
        columnWidth,
        !isNewStyle &&
          "bg-creator-primary-background pit-scrollbar border-l-2 border-[var(--pits-menu-border)]"
      )}
    >
      {strategy?.GetContent() ?? ""}
    </div>
  );
}
